<template>
	<div class="index_page">
		<!-- 顶部选项卡 -->
		<top-bar></top-bar>
		<!-- 顶部选项卡 end -->
		
		<!-- 子路由 -->
		<transition name="fade_transition" mode="out-in">
			<router-view></router-view>
		</transition>
		<!-- 子路由 end-->
		
		<!-- 底部 -->
		<Footer></Footer>
		<!-- 底部 end -->
		
		<!-- 悬浮功能组 -->
		<floating-group></floating-group>
		<!-- 悬浮功能组 end -->
	</div>
</template>

<script>
	import TopBar from './components/top_bar.vue';
	import Footer from './components/footer.vue';
	import FloatingGroup from './components/floating_group.vue';
	
	export default{
		components: {
			TopBar,
			Footer,
			FloatingGroup
		}
	}
</script>

<style scoped>
	.index_page{ position: relative;padding: 80px 0 0 0; }
</style>
